module.exports = __webpack_public_path__ + "media/angel.01e51ef1.mp4";